import { render, staticRenderFns } from "./ProductCustomiser.vue?vue&type=template&id=8b7f70ba&"
import script from "./ProductCustomiser.vue?vue&type=script&lang=js&"
export * from "./ProductCustomiser.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomiser.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,CustomiserTabs: require('/opt/build/repo/storefront/components/molecules/Product/CustomiserTabs.vue').default,TertiaryButton: require('/opt/build/repo/storefront/components/atoms/Button/TertiaryButton.vue').default,BaseToggle: require('/opt/build/repo/storefront/components/atoms/Input/BaseToggle.vue').default,SlideDownTransition: require('/opt/build/repo/storefront/components/atoms/Transition/SlideDownTransition.vue').default,CustomiserRow: require('/opt/build/repo/storefront/components/molecules/Product/CustomiserRow.vue').default})
